module.exports = __webpack_public_path__ + "static/media/cabins-prem-economy.2ae629a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightPage/img/cabins-prem-economy.png
// module id = 997
// module chunks = 0